import React from "react";
import { PixelPerson } from "../../pixelPerson";
import "./AgentTemplateSprite.css";

/**
 * Deterministic pixel-person sprite for agent creation templates. Uses the
 * template name (or seed) so each template keeps a stable character identity.
 */
export default function AgentTemplateSprite({
  seed = "",
  name,
  size = 36,
}) {
  return (
    <PixelPerson
      className="agent-template-sprite"
      name={name || seed}
      size={size}
      animated
    />
  );
}
